module.exports = __webpack_public_path__ + "static/media/rm.3d9c0fb8.png";